import { Button, MultiSelectDropDown } from '@/components/Common';
import { useFaqList } from './FaqList.hook';

const FaqFilter = () => {
  const { filteredFaqs, openCreateFaq, handleStatusFilterChange, selectedFaq } =
    useFaqList();

  return (
    <div className="flex gap-2 items-center justify-between">
      <div className="flex flex-col">
        <h2 className="text-white text-[32px] font-bold">
          {selectedFaq?.name}
        </h2>
        {filteredFaqs && (
          <span className="text-base not-italic font-normal  text-[#616163]">
            {filteredFaqs?.length ? `${filteredFaqs?.length} question(s)` : ''}
          </span>
        )}
      </div>

      <div className="flex items-start gap-4 w-[40%]">
        <MultiSelectDropDown
          options={[
            { _id: 'true', name: 'Publié' },
            { _id: 'false', name: 'Brouillon' },
          ]}
          handleChange={handleStatusFilterChange}
          placeholder="Status"
        />
        <Button title="Ajouter une question" onClick={openCreateFaq} />
      </div>
    </div>
  );
};

export default FaqFilter;
